import { useState, useEffect } from 'react';

const SIDEBAR_TRANSITION_MS = 250;

/**
 * collapsed 상태 변경 시 label 표시를 지연시키는 훅.
 * 사이드바가 접힐 때는 즉시 숨기고, 펼쳐질 때는 transition 완료 후 표시한다.
 */
export function useDelayedVisibility(collapsed: boolean | undefined): boolean {
  const [visible, setVisible] = useState(!collapsed);

  useEffect(() => {
    if (collapsed) {
      setVisible(false);
    } else {
      const timer = setTimeout(() => setVisible(true), SIDEBAR_TRANSITION_MS);
      return () => clearTimeout(timer);
    }
  }, [collapsed]);

  return visible;
}
